export const BTN_CANCEL = "NEIN";
export const BTN_ACCEPT = "JA";
export const BTN_DELETE = "LÖSCHEN";